import { Compress } from "./fileManager";

export function getOriginalAsset(assets, uiid_asset) {
  let base64 = assets.find(asset => asset.uuid === uiid_asset)?.data;
  let newBase64 = base64;
  if (!base64) return null;

  return newBase64;

}

export async function getAsset(assets, uiid_asset, quality = 100) {
  let base64 = assets.find(asset => asset.uuid === uiid_asset)?.data;
  let newBase64 = base64;
  if (!base64) return null;

  if (quality !== 100) {
    newBase64 = await Compress(base64, quality);
  }

  return newBase64;

}

export function generateUUID() {
  const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0; // Número aleatório entre 0 e 15
      const v = c === 'x' ? r : (r & 0x3 | 0x8); // Garantir o bit específico para 'y'
      return v.toString(16); // Converter para hexadecimal
  });
}